// extracted by mini-css-extract-plugin
export default {"cta":"KH-z","disabled":"LH-z"};